import { render, staticRenderFns } from "./ProgramFormWidget.vue?vue&type=template&id=45557b9b&scoped=true"
import script from "./ProgramFormWidget.vue?vue&type=script&lang=js"
export * from "./ProgramFormWidget.vue?vue&type=script&lang=js"
import style0 from "./ProgramFormWidget.vue?vue&type=style&index=0&id=45557b9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45557b9b",
  null
  
)

export default component.exports